import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import { FlatButton } from '../buttons';

const NotificationModal = ({ showNotification, closeNotification, text }) => {
  return (
    <Dialog
      open={showNotification}
      onRequestClose={closeNotification}
      autoScrollBodyContent
      contentClassName="user-groups-modal"
      paperClassName="user-groups-paper"
    >
      <div className="ml-upgrade-dialog-content custom-dialog">
        <div>
          <h3>Notice</h3>

          {text}
        </div>

        <FlatButton
          label="Close"
          onClick={() => {
            closeNotification();
          }}
          primary
        />
      </div>
    </Dialog>
  );
};

NotificationModal.propTypes = {
  showNotification: PropTypes.bool,
  closeNotification: PropTypes.bool,
  text: PropTypes.element.isRequired,
};

NotificationModal.defaultProps = {
  showNotification: false,
  closeNotification: null,
};

export default NotificationModal;
